export class PayerBank  {
    urlRedirect: string = ""; // Banorte: RESPONSEURL
    company: PayerCompany = new PayerCompany();
    requestMode: string = ""; // Banorte: MODE *
    paymentCount: string = ""; // Banorte: COUNT *
    payments: Array<PaymentsBank> = [];  // Banorte: row
    customer: Customer = new Customer();
    user: User = new User();
    version: number = 1; // Banorte: If the value is 1, version 1 of the electronic check is requested, if the value is 2, version 2 of the electronic check is requested.
}

class PayerCompany {
    companyCode: string = "";
    companyDesc: string = "";
}

export class PaymentsBank {
    row: string = ""; // Banorte: row
    paymentAmount?: string = ""; // Banorte: AMOUNT<row>
    agreementCode?: string = ""; // Banorte: CLIENTID<row> *
    reference?: Reference = new Reference();  // Banorte: REFERENCE<row> -> *
    transaction?: Transaction = new Transaction(); // Banorte: CONCEPT<row>
    method?: Method = new Method();
    currency?: Currency = new Currency();
    datePayment?: string = "";
    timePayment?: string = "";
    partialPayment?: string ="";
}

class Reference {
    referenceNumber: string = "" // Banorte: REFERENCE<row> -> *
}

class Transaction {
    transactionType: string = "";
    transactionDesc: string = ""; // Banorte: CONCEPT<row>
}

class Method {
    methodType: string = "";
    methodDesc: string = "";
}

class Currency {
    currencyType: string = "";
    currencyDesc: string = "";
}

class Customer {
    customerCode: string = ""; // Banorte: ID<row>
    customerDesc: string = "";
}

class User {
    userAccount: string = "";
    userName: string = "";
}
